/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	export class Activity {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(json:object) {
			this.isAvailable = true;

			const data:object = json['activity'];
			const map:object = data['map'];
			const user:object = data['user'];

			this.id = data['id'];

			this.timeZone = 0;
			if (map && map['time_zone'] !== null) {
				this.timeZone = map['time_zone'];
			}

			if (data['three_dimension_map']) {
				this.threeDimensionMap = new ActivityThreeDimensionMap(data['three_dimension_map']);
			} else {
				this.threeDimensionMap = null;
			}

			let dataList;
			let dataCount;

			this.landmarks = [];
			dataList = data['checkpoints'];
			if (dataList) {
				dataCount = dataList.length;
				for (let i:number = 0; i < dataCount; ++i) {
					this.landmarks.push(new ActivityLandmark(dataList[i]));
				}
			}

			this.photos = [];
			dataList = data['images'];
			if (dataList) {
				dataCount = dataList.length;
				for (let i:number = 0; i < dataCount; ++i) {
					this.photos.push(new ActivityPhoto(dataList[i]));
				}
			}

			this.mapName = '';
			if (map && map['name'] !== null) {
				this.mapName = map['name'];
			}

			this.userName = '';
			if (user && user['name'] !== null) {
				this.userName = user['name'];
			}

			this.userImageUrl = 'image/default-user-image.png';
			if (user && user['image'] !== null && user['image']['thumb_square_small_url'] !== null) {
				this.userImageUrl = user['image']['thumb_square_small_url'];
			}

			// replace cdn origin
			//this.userImageUrl = this.userImageUrl.replace('cdn.yamap.co.jp', 'yamap-image-convert-production-1484101480.ap-northeast-1.elb.amazonaws.com');

			// use local dummy
			//this.userImageUrl = 'image/default-user-image.png';

			trace('[Activity] raw :', json);
			trace('[Activity]', this);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getIsAvailable():boolean {
			return this.isAvailable;
		}

		public getId():string {
			return this.id;
		}

		public getTimeZone():number {
			return this.timeZone;
		}

		public getLandmarks():ActivityLandmark[] {
			return this.landmarks;
		}

		public getPhotos():ActivityPhoto[] {
			return this.photos;
		}

		public getThreeDimensionMap():ActivityThreeDimensionMap {
			return this.threeDimensionMap;
		}

		public getMapName():string {
			return this.mapName;
		}

		public getUserName():string {
			return this.userName;
		}

		public getUserImageUrl():string {
			return this.userImageUrl;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isAvailable:boolean;

		private id:string;
		private timeZone:number;
		private landmarks:ActivityLandmark[];
		private photos:ActivityPhoto[];
		private threeDimensionMap:ActivityThreeDimensionMap;

		// for recording mode
		private mapName:string;
		private userName:string;
		private userImageUrl:string;
	}
}
